import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const articles = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}>
            精选文章
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            深入探索善意社交的智慧，开启高质量人际关系之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:border-accent-300/50"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {article.readTime} 分钟阅读
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors"
                  style={{ fontFamily: 'var(--font-heading)' }}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-xs font-medium text-foreground-700">
                    {article.author}
                  </span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/ren-shan-jiao-li-nian"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300/60 rounded-full text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer transition-all duration-300 whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}